import { render, staticRenderFns } from "./navbar-desktop.vue?vue&type=template&id=39f96042&scoped=true&"
import script from "./navbar-desktop.vue?vue&type=script&lang=js&"
export * from "./navbar-desktop.vue?vue&type=script&lang=js&"
import style0 from "./navbar-desktop.vue?vue&type=style&index=0&id=39f96042&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f96042",
  null
  
)

export default component.exports